import axios from 'axios';
import { DESIGN_API_URL } from '../lib/environment.js';

const tagSets = () => {
	return {
		create: (tagSetObject) => {
			return new Promise((resolve, reject) => {
				const controller = new AbortController();

				let timeout = setTimeout(() => {
					controller.abort();
				}, 180000);

				axios({
					url: `${DESIGN_API_URL}/tagSets`,
					method: 'POST',
					cache: 'no-cache',
					data: tagSetObject,
					signal: controller.signal,
				})
					.then((resp) => {
						clearTimeout(timeout);

						if (resp.data.status === 0) {
							resolve(resp.data.result);
						} else {
							reject(resp.data.result);
						}
					})
					.catch((err) => {
						clearTimeout(timeout);
						reject(err);
					});
			});
		},

		read: () => {
			return new Promise((resolve, reject) => {
				const controller = new AbortController();

				let timeout = setTimeout(() => {
					controller.abort();
				}, 180000);

				axios({
					url: `${DESIGN_API_URL}/tagSets`,
					method: 'GET',
					cache: 'no-cache',
					signal: controller.signal,
				})
					.then((resp) => {
						clearTimeout(timeout);

						if (resp.data.status === 0) {
							resolve(resp.data.result);
						} else {
							reject(resp.data.result);
						}
					})
					.catch((err) => {
						clearTimeout(timeout);
						reject(err);
					});
			});
		},

		update: (tagSetId, tagSetObject) => {
			return new Promise((resolve, reject) => {
				const controller = new AbortController();

				let timeout = setTimeout(() => {
					controller.abort();
				}, 180000);

				axios({
					url: `${DESIGN_API_URL}/tagSets/${tagSetId}`,
					method: 'PATCH',
					cache: 'no-cache',
					data: tagSetObject,
					signal: controller.signal,
				})
					.then((resp) => {
						clearTimeout(timeout);

						if (resp.data.status === 0) {
							resolve(resp.data.result);
						} else {
							reject(resp.data.result);
						}
					})
					.catch((err) => {
						clearTimeout(timeout);
						reject(err);
					});
			});
		},

		delete: (tagSetId) => {
			return new Promise((resolve, reject) => {
				const controller = new AbortController();

				let timeout = setTimeout(() => {
					controller.abort();
				}, 180000);

				axios({
					url: `${DESIGN_API_URL}/tagSets/${tagSetId}`,
					method: 'DELETE',
					cache: 'no-cache',
					signal: controller.signal,
				})
					.then((resp) => {
						clearTimeout(timeout);

						if (resp.data.status === 0) {
							resolve(resp.data.result);
						} else {
							reject(resp.data.result);
						}
					})
					.catch((err) => {
						clearTimeout(timeout);
						reject(err);
					});
			});
		},
	};
};

const singleton = tagSets();
Object.freeze(singleton);

export default singleton;
